import React, {Fragment, useEffect, useState} from 'react';
import parse from 'html-react-parser';
import BuyGiftCard from './BuyGiftCard';
import {Card, Col, Divider, Flex, Row, Tag, Typography} from 'antd';
import {BackButtonWText, SnackBar} from 'Components';
import {useSelector} from 'react-redux';
import MemberAccountInfo from './MemberAccountInfo';
import {gqlBuyGiftCard} from 'GQL/MethodsBFF/GMGifting';
import {resetGMOrderHistory} from 'Redux/Slices/gmGiftingHistory';
import {useSnackBar} from 'Hooks';
const DEFAULT_BUYNOW_ERROR = 'An unexpected error occured';

interface IBuyGiftCardResponse {
  offerCompositeKey: OfferCompositeKey;
  agentId: string;
}

export interface OfferCompositeKey {
  offerId: string;
  externalId: string;
  offerSource: string;
  details: Details;
}

export interface Details {
  giftCardType: string;
  amount: number;
  quantity: number;
  contentProvider: string;
  email: string;
  firstName?: string;
  lastName?: string;
  line1?: string;
  line2?: string;
  city?: string;
  region?: string;
  postalCode?: string;
  country?: string;
  phoneNumber?: string;
  lastFourCardNum?: string;
}

interface ISingleGiftCardProps {
  offer: any;
  toggleView: any;
}

function GMGiftDetailView(props: ISingleGiftCardProps) {
  useEffect(() => {
    setAccount(false);
  }, [props.offer]);
  const authtoken = useSelector((state: any) => {
    return state?.impersonateToken.impersonateToken?.accessToken;
  });
  const tenantID = useSelector((state: any) => {
    return state?.login.tenantID;
  });
  const {offer, toggleView} = props;
  const [errorMessage, setErrorMessage] = useState('');
  const [giftErrorMessage, setgiftErrorMessage] = useState('');
  const [errorType, setErrorType] = useState('');
  const [updateAccount, setAccount] = useState(true);
  const [isSnackBarOpen, closeSnackBar] = useSnackBar(errorMessage);
  const selectedMember = useSelector((state: any) => state?.selectedMember);
  const buyOffer = async (
    amount: number,
    quantity: number,
    cc4digit: string,
    agentUserName: string,
  ) => {
    setErrorMessage('');
    const selectedOffer: IBuyGiftCardResponse = {
      offerCompositeKey: {
        offerId: offer?.id,
        externalId: offer?.externalId,
        offerSource: offer?.offerSource,
        details: {
          giftCardType: offer?.redemptionDetails[0].method === 'DIGITAL' ? 'egift' : 'physical',
          amount: amount,
          quantity: quantity,
          contentProvider: offer?.externalId,
          email: selectedMember && selectedMember.primaryEmail ? selectedMember.primaryEmail : '',
          lastFourCardNum: cc4digit,
          firstName: '',
          lastName: '',
          line1: '',
          line2: '',
          city: '',
          region: '',
          postalCode: '',
          country: '',
          phoneNumber: '',
        },
      },
      agentId: agentUserName ? agentUserName : '',
    };

    try {
      const headers = {
        'tenant-id': tenantID,
        Authorization: `Bearer ${authtoken}`,
      };
      let response = await gqlBuyGiftCard(selectedOffer, headers);
      if (response?.data?.claimOfferAsAgent) {
        toggleView(true);
        setAccount(true);
        setErrorType('success');
        setErrorMessage('ORDER COMPLETE');
        resetGMOrderHistory();
      } else {
        setgiftErrorMessage(response.error?.graphQLErrors[0].message);
      }
    } catch (error: any) {
      let errorMessage: string = DEFAULT_BUYNOW_ERROR;
      setErrorMessage(errorMessage);
    }
  };

  return (
    <Fragment>
      <SnackBar
        severity={errorType}
        errorMessage={errorMessage}
        closeSnackBar={closeSnackBar}
        isSnackBarOpen={isSnackBarOpen}
      />
      <div>
        <Flex justify="space-between">
          <BackButtonWText text="Back to list" callback={toggleView} />{' '}
          <MemberAccountInfo updateAccount={updateAccount} />
        </Flex>
        <Card style={{marginTop: 16, marginBottom: 16}}>
          <Flex vertical gap={16}>
            <Row gutter={16}>
              <Col span={12}>
                <div style={{textAlign: 'center'}}>
                  <img
                    src={offer?.images[0]?.imageUrl}
                    alt="giftcard"
                    className="single_gift_img"
                  />
                </div>
                <div style={{textAlign: 'center', marginTop: 10}}>
                  <Tag
                    color={offer?.redemptionDetails[0].method === 'PHYSICAL' ? 'default' : 'blue'}>
                    {offer?.redemptionDetails[0].method === 'PHYSICAL' ? 'Plastic' : 'eGift'}
                  </Tag>
                </div>
                <Typography.Text strong style={{display: 'block', paddingTop: 20}}>
                  {offer?.title}
                </Typography.Text>
                <div style={{marginTop: 10}}>{offer?.description}</div>
              </Col>
              <Col span={10} style={{marginLeft: 32}}>
                <BuyGiftCard
                  min={offer?.valueRestrictions?.minimum}
                  max={offer?.valueRestrictions?.maximum}
                  buyOffer={buyOffer}
                  giftCardType={
                    offer?.redemptionDetails[0].method === 'PHYSICAL' ? 'Plastic' : 'eGift'
                  }
                  error={giftErrorMessage}
                  clearError={() => setgiftErrorMessage('')}
                  loginData={[]}
                />
              </Col>
            </Row>
            <Divider />
            <div>
              <Typography.Text strong style={{display: 'block', paddingTop: 20}}>
                Special Conditions
              </Typography.Text>
              {parse(offer?.termsAndConditions)}
            </div>
          </Flex>
        </Card>
      </div>
    </Fragment>
  );
}

export default GMGiftDetailView;
